import { render, staticRenderFns } from "./Postponement.vue?vue&type=template&id=02ceadd4&scoped=true&"
import script from "./Postponement.vue?vue&type=script&lang=js&"
export * from "./Postponement.vue?vue&type=script&lang=js&"
import style0 from "./Postponement.vue?vue&type=style&index=0&id=02ceadd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ceadd4",
  null
  
)

export default component.exports